module.exports = __webpack_public_path__ + "static/media/crozerkeystone.bf29aeae.png";